import { ReportSettingsSpotExplanation } from "@common/helpers/report-settings/explain-report-setting-spot";
import { UpdateReportSetting } from "../layout/reportSettingsDrafts";
import { TemplateNames } from "../reportSettingsSourceCopy";
import {
    AMOUNT_SCALE_OPTIONS,
    amountScaleDescription,
    CURRENCY_PLACEMENT_OPTIONS,
    CURRENCY_SYMBOL_OPTIONS,
    DECIMAL_PLACES_OPTIONS,
    NEGATIVE_FORMAT_OPTIONS,
    PERCENT_DECIMAL_PLACES_OPTIONS,
    ZERO_DISPLAY_OPTIONS,
} from "./numberFormatControls";
import {
    NumberFormatSelectRow,
    NumberFormatSwitchRow,
} from "./numberFormatRows";

interface Props {
    view: ReportSettingsSpotExplanation;
    templateNames: TemplateNames;
    canEdit: boolean;
    updateField: UpdateReportSetting;
}

export const NumberFormatSection = ({
    view,
    templateNames,
    canEdit,
    updateField,
}: Props) => {
    const rowContext = { view, templateNames, canEdit, updateField };

    return (
        <>
            <NumberFormatSelectRow
                {...rowContext}
                label="Negative numbers"
                field="negativeFormat"
                options={NEGATIVE_FORMAT_OPTIONS}
            />
            <NumberFormatSwitchRow
                {...rowContext}
                label="Show negatives in red"
                field="isNegativeInRed"
            />
            <NumberFormatSelectRow
                {...rowContext}
                label="Decimal places"
                field="decimalPlaces"
                options={DECIMAL_PLACES_OPTIONS}
            />
            <NumberFormatSelectRow
                {...rowContext}
                label="Currency symbol"
                field="currencySymbol"
                options={CURRENCY_SYMBOL_OPTIONS}
            />
            <NumberFormatSelectRow
                {...rowContext}
                label="Currency symbol placement"
                field="currencyPlacement"
                options={CURRENCY_PLACEMENT_OPTIONS}
            />
            <NumberFormatSelectRow
                {...rowContext}
                label="Zero amounts"
                field="zeroDisplay"
                options={ZERO_DISPLAY_OPTIONS}
            />
            <NumberFormatSwitchRow
                {...rowContext}
                label="Thousands separator"
                field="hasThousandsSeparator"
            />
            <NumberFormatSelectRow
                {...rowContext}
                label="Amount scale"
                field="amountScale"
                options={AMOUNT_SCALE_OPTIONS}
                description={amountScaleDescription(
                    view.amountScale.effective.value,
                )}
            />
            <NumberFormatSelectRow
                {...rowContext}
                label="Percentage decimals"
                field="percentDecimalPlaces"
                options={PERCENT_DECIMAL_PLACES_OPTIONS}
            />
        </>
    );
};
